import PropTypes from 'prop-types';

export default PropTypes.arrayOf(
  PropTypes.shape({
    url: PropTypes.string,
    text: PropTypes.node.isRequired
  })
);
